import { LAYERS_NORMALIZED_MAX, loadHtmlImage } from "./layerGeometry";

export const composeLayersToBlob = async ({
  layers = [],
  canvasWidth,
  canvasHeight,
}) => {
  const width = Number(canvasWidth);
  const height = Number(canvasHeight);
  if (!width || !height) {
    throw new Error("Missing canvas size for layer compose");
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  const sortedLayers = [...layers].sort(
    (left, right) => (left.zIndex || 0) - (right.zIndex || 0)
  );

  for (const layer of sortedLayers) {
    if (!layer?.url) continue;
    const image = await loadHtmlImage(layer.url);
    const x = ((Number(layer.x) || 0) / LAYERS_NORMALIZED_MAX) * width;
    const y = ((Number(layer.y) || 0) / LAYERS_NORMALIZED_MAX) * height;
    const drawWidth =
      ((Number(layer.width) || 0) / LAYERS_NORMALIZED_MAX) * width;
    const drawHeight =
      ((Number(layer.height) || 0) / LAYERS_NORMALIZED_MAX) * height;
    context.drawImage(image, x, y, drawWidth, drawHeight);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Could not compose layered image"));
        return;
      }
      resolve(blob);
    }, "image/png");
  });
};
